// extracted by mini-css-extract-plugin
export default {"toggleSwitch":"NC7jzjBwn5igCt5Do3dA"};